export default {
  SEND_COMMAND: 'sendCommand',
}